import React, { useState } from 'react';
import { ReactSVG } from 'react-svg';
import {getPublicImagePath, ToggleMenu, useAppState, useBreakpoints} from '@nutastic/nutastic-react-app';
import classnames from 'classnames';

const Header = () => {
    const { headerNavItems = [] } = useAppState();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const { lg: isLargeScreen } = useBreakpoints();
    const componentClass = 'header';
    const navigationLinks = headerNavItems.map((n, i) => {
        const { href, title, new_window: newWindow } = n;
        const target = parseInt(newWindow) ? '_blank' : '_self';
        return <li key={i}><a href={href} target={target} rel="noreferrer">{ title }</a></li>;
    });

    const menuButtonClasses = classnames(`${componentClass}__menuBtn`, {
        'ion-ios-keypad': !isMenuOpen,
        'ion-ios-close': isMenuOpen,
        isOpen: isMenuOpen
    });

    return <header className={ componentClass }>
        <div className="container h-100">
            <a href="/" className={`${componentClass}__title`}>Especially For You <i>by Joslin</i></a>
            { isLargeScreen && <ul>{ navigationLinks }</ul> }
        </div>
        { !isLargeScreen && <i className={ menuButtonClasses } onClick={() => setIsMenuOpen(!isMenuOpen)} /> }
        <ToggleMenu isOpen={isMenuOpen} animation="slideFromRight" onOuterClick={() => setIsMenuOpen(false)}>
            <ul>{ navigationLinks }</ul>
        </ToggleMenu>
    </header>;
};

export default Header;
